// removed by extract-text-webpack-plugin
module.exports = {"statisticsMapContainer":"_2EeF_ZWSFCEAzocjdaTl_6","markersList":"uA-mrxU5w_jQHToJHlt6k","listItem":"_26MGJKiK7z0U1xJuLWsWD6","title":"_1uxYl2NWcteLFTeFK-AJNR","deviceId":"_3fhckzpSWg43b6i-ovVOaO","deviceStatusOn":"_1AdYQrNHEYFoo5nNddo0Kz","deviceStatusOff":"_1Xf1c1XzpMYewfaR-oC2a-","content":"_3UYP8UxjnPy5XZzCn69yvh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsMap.less
// module id = 1517
// module chunks = 0